import { useState } from "react";
import { MainButtonInput } from "../mainComponent/mainButtonInput";
import { MainInput } from "../mainComponent/mainInput";
import PatientApi from "../services/PatientApi";
import { useNavigate } from "react-router-dom";

function ForgotMpinPatient(props) {
    const { mobile, doctorId } = props;
    const { PatientForgetMpin } = PatientApi()
    const [isError, setIsError] = useState('');
    const navigate = useNavigate();
    const [data, setData] = useState(
        {
            password: '',
            confirmPassword: ''
        }
    );
    const handleChange = (event) => {
        const { name, value } = event.target;
        setData({ ...data, [name]: value });
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        const password = data.password.trim();
        const confirmPassword = data.confirmPassword.trim();
        if (mobile.length < 10 || !/^\d+$/.test(mobile)) {
            setIsError('Invalid mobile number');
            return;
        }
        if (password === '' || confirmPassword === '') {
            setIsError("Password fields cannot be empty");
            return
        }
        if (password !== confirmPassword) {
            alert('Passwords do not match');
            return;
        }
        else if (password === confirmPassword) {
            const bodyData = {
                mobile: mobile,
                password: password,
            }
            PatientForgetMpin(bodyData)
                .then(response => {
                    const patientId = response.data._id
                    navigate(`/appointments/${doctorId}/patientprofile/${patientId}`)
                })
        } else {
            setIsError('error occure');
        }
    };

    return (
        <div className="row full-width">
            <lable className='mb-2 font_weight'>Enter MPIN</lable>
            <div className="col-md-12">
                <MainInput
                    type="password"
                    name="password"
                    maxLength={6}
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    onChange={handleChange}
                    placeholder="New MPIN"
                    required
                >
                </MainInput>
            </div>
            <lable className='mb-2 font_weight'>Confirm MPIN</lable>
            <div className="col-md-12">
                <MainInput
                    type="password"
                    name="confirmPassword"
                    maxLength={6}
                    pattern="[+-]?\d+(?:[.,]\d+)?"
                    onChange={handleChange}
                    placeholder="Confirm MPIN"
                    required>
                </MainInput>
            </div>
            <div className="width25">
                <MainButtonInput onClick={handleSubmit}>Set Mpin</MainButtonInput>
            </div>
            {isError !== '' ? <div className="validation mt-3 ml-3">
                {isError}
            </div>
                : null}
        </div>
    )

}
export { ForgotMpinPatient }